import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import {filter} from 'rxjs/operators';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-card-version-two',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  // spinner
  loading = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 80;
  paymentMethod: string = 'card';
  session: Session;
  hidePgLogo = false;

  constructor(
    private router: Router, 
    private route: ActivatedRoute, 
    private sessionService: SessionService
  ) { 
    sessionStorage.setItem('selected-payment', 'card');

    // router.events
    // .pipe(
    //   filter(
    //     (events) => {
    //       return (events instanceof NavigationStart);
    //     }
    //   )
    // )
    // .subscribe((events: NavigationStart) => {
    //   if (events.navigationTrigger === 'popstate') {
    //     this.router.navigate([this.session.virtualRoute])
    //       .then((data) => {
    //         this.loading = false;
    //       });
    //   }
    // });

    this.route.queryParams.subscribe((params: { initialised }) => {
      if (params.initialised) {
        this.router.navigate(['tds'],{relativeTo:this.route});
      }
    });

    this.session = JSON.parse(sessionStorage.getItem('sessionData'));

    // router.events
    // .pipe(
    //   filter(
    //     (events) => {
    //       return (events instanceof NavigationStart);
    //     }
    //   )
    // )
    // .subscribe((events: NavigationStart) => {
    //   if (events.navigationTrigger === 'popstate') {
    //     this.router.navigate([this.session.virtualRoute])
    //     .then((data) => {
    //       this.loading = false;
    //     });
    //   }
    // });
  }

  ngOnInit(): void {
    this.hidePgLogo = this.session?.sessionDisplayInformation?.hidePgLogo === 'true';
    
    // Only redirect to 'add' if we're at the base card route without any subpath
    const currentUrl = this.router.routerState.snapshot.url;
    const isBaseCardRoute = currentUrl.endsWith('/card') || currentUrl.endsWith('/card/');
    
    if (isBaseCardRoute) {
      this.router.navigate(['add'], { relativeTo: this.route });
    }
    this.loading = false;
  }

}
